// 支付接口API
// import request from '@/utils/request';
import ajax from './_ajax';

// export const alipay = function (params) {
//   return request({
//     url: '/api/order/alipay',
//     method: 'post',
//     params: params
//   });
// };

const api = {};
api.orderGetById = function (id) {
  return ajax.get('/api/Order/GetById?id=' + id);
};
api.wxQrCodePrepay = function (data) {
  return ajax.post('/api/WxPay/WxQrCodePrepay', data);
};
api.aliQrCodePay = function (data) {
  return ajax.post('/api/AliPay/AliQrCodePay', data);
};
api.getPaymentTips = function () {
  return ajax.get('/api/Order/GetPaymentTypes');
};
api.getCheckIsPayOrder = function (data) {
  return ajax.get('/api/order/GetCheckIsPayOrder?orderId=' + data);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/payment.js